import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../services/authentication.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  @Input() user;
  @Input() component;
  @Input() messageService : MessageService;
    
  public password : string = "";
  public confirmPassword : string = "";
  public busy : boolean = false;
  public error : boolean = false;
  public errorMessage : string = "";

  constructor(
    public modal : NgbActiveModal,
    private authService : AuthenticationService
  ) { }

  ngOnInit() {
  }

  changePassword(){
    this.busy = true;
    this.error  = false;
      this.authService.resetUserPassword(this.user.ID, this.password).subscribe(
        result=>{          
          this.busy = false;
          this.password = "";
          this.confirmPassword = "";
          this.messageService.add({ life: 5000, summary: "Password Reset", detail: "The users password has been reset."});
          this.component.hide();
      },error=>{
        this.component.hide();
        this.busy = false;
      },()=>{
        this.component.hide();
        this.busy = false;
      });
  }

}
